import React from "react";
import {AccountingPeriod, AccountingPeriodRestControllerApiFactory} from "arteco-api-client-ts";
import {FormContent} from "../../../../components/form/form_inputs/form_buttons";
import {FormInput} from "../../../../components/form/form_inputs/form_input";
import FormSelect from "../../../../components/form/form_inputs/form_select";
import {types} from "../../../../components/form/types";
import {Chip, Grid} from "@mui/material";
import {useForm, UseFormProps} from "../../../../components/form/form_model";
import {useApiManager} from "../../../../components/utils/api";
import {FormButtonProps} from "../../../../components/form/form_inputs/form_button";

const statusColor: Record<string, "default" | "success" | "warning" | "error"> = {
    ABIERTO: "success",
    CERRADO: "warning",
    BLOQUEADO: "error",
};

export const AccountingPeriodEditPage = () => {
    const apiManager = useApiManager();
    const ctrl = apiManager.factory(AccountingPeriodRestControllerApiFactory);

    const form = useForm({
        fetcher: (id) => ctrl.getAccountingPeriod(id),
        updater: (bean) => ctrl.saveAccountingPeriod(bean),
        remover: (id) => ctrl.deleteOrDismissAccountingPeriod(id),
        factory: () => ({yearValue: new Date().getFullYear(), status: 'ABIERTO'} as AccountingPeriod),
        extraActions: [
            {
                label: "Cerrar período",
                action: () => {
                    const id = form.getIdOrErr();
                    apiManager.execute(ctrl.closeAccountingPeriod(id), "Período cerrado")
                        .then((p) => form.setter(p));
                },
            } as FormButtonProps,
            {
                label: "Bloquear período",
                action: () => {
                    const id = form.getIdOrErr();
                    apiManager.execute(ctrl.lockAccountingPeriod(id), "Período bloqueado")
                        .then((p) => form.setter(p));
                },
            } as FormButtonProps,
        ],
    } as UseFormProps<AccountingPeriod>);

    const bean = form.propModel.value;

    return (
        <FormContent form={form} title={"Formulario de período contable"}>
            <Grid container spacing={3}>
                <Grid item sm={2}>
                    <FormInput field={"yearValue"} label={"Año"} type="number"/>
                </Grid>
                <Grid item sm={6}>
                    <FormInput field={"name"} label={"Nombre"}/>
                </Grid>
                <Grid item sm={4} sx={{display: "flex", alignItems: "center", pt: 4}}>
                    <Chip
                        label={bean?.status ?? "ABIERTO"}
                        color={statusColor[bean?.status ?? "ABIERTO"] ?? "default"}
                    />
                </Grid>
            </Grid>

            <Grid container spacing={3}>
                <Grid item sm={6}>
                    <FormInput field={"startDate"} label={"Fecha inicio"} type="date"/>
                </Grid>
                <Grid item sm={6}>
                    <FormInput field={"endDate"} label={"Fecha fin"} type="date"/>
                </Grid>
            </Grid>

            <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                    <FormSelect
                        field={"officialSource"}
                        label={"Fuente oficial"}
                        type={types.accountingSources}
                        helperText={"Qué asientos cuentan los informes de este ejercicio. CONTASOL: los importados; EXTRANET: los anotados aquí; vacío: todos (mientras no se solapan)."}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormInput
                        field={"extranetFrom"}
                        label={"Cuenta la Extranet desde"}
                        type="date"
                        helperText={"Desde esta fecha cuentan los asientos de la Extranet; lo importado de Contasol queda solo para el cuadre. Antes, la fuente oficial."}
                    />
                </Grid>
            </Grid>
        </FormContent>
    );
};
